import React, { useState, useEffect } from "react";
import Tooltip from '@mui/material/Tooltip';

function Form() {
  const [token, setToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPRTG, setShowPRTG] = useState(false);
  const SUBMIT_KEY = `azureSaasSubmitted_${token || "default"}`;
  const [submitted, setSubmitted] = useState(false);
  const [prtgAuthType, setPrtgAuthType] = useState("passhash"); // "passhash" or "apikey"

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePassword2Visibility = () => {
    setShowPassword2(!showPassword2);
  };

  // Function to get the token parameter from the URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get("token");
    if (tokenParam) {
      setToken(tokenParam);
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem(SUBMIT_KEY) === "yes") {
      setSubmitted(true);            // form was already sent in this tab
    }
  }, [SUBMIT_KEY]);

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    // Convert form data to a JSON object
    const data = {
      name: formData.get("name"),
      company: formData.get("company"),
      email: formData.get("email"),
      tenant: formData.get("tenant"),
      app: formData.get("app"),
      secret: formData.get("secret"),
      token, // Include the token from the URL
      prtgip: formData.get("prtg"),
      prtgport: formData.get("prtgport"),
      prtguser: formData.get("user"),
      prtgpass: formData.get("pass"),
      prtguuid: formData.get("prtguuid"),
      prtgprobename: formData.get("prtgprobename"),
      prtgauthtype: prtgAuthType,
    };
    if (!showPRTG) {
      data.prtgip = "";
      data.prtgport = "";
      data.prtguser = "";
      data.prtgpass = "";
      data.prtguuid = "";
      data.prtgprobename = "";
      data.prtgauthtype = "";
    }

    try {
      const response = await fetch("https://acp.automonx.net:5000/azuresaas", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        sessionStorage.setItem(SUBMIT_KEY, "yes");   // ⟵ NEW
        setSubmitted(true); 
        //alert("Form submitted successfully!");
      } else {
        try {
          const errorData = await response.json();
          if (errorData && errorData.message) {
            alert(`Failed to submit the form: ${errorData.message}`);
          } else {
            alert("Failed to submit the form. (No details provided)");
          }
        } catch (parseError) {
          alert("Failed to submit the form. (Could not parse error)");
        }
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("An error occurred. Please try again later."+ error.toString());
    }
  };

  return (
    <div style={styles.container}>
      <img src="/logo_black.png" height="77" width="400" />
      <h1 style={styles.header}>Sensor Pack for Azure - SAAS Order</h1>
      <div style={styles.textContainer}>
        <p>You have reached this page after ordering the AutoMonX Sensor Pack for Azure SAAS in the Microsoft Azure Marketplace. In order to deploy your SAAS offering, please fill the details below.</p>
        <p>You may want to read our <a href="https://www.automonx.com/post/configuring-azure-for-monitoring-with-the-azure-sensor-pack" target="_blank">Azure credentials guide</a> to prepare for filling the form.</p>
        <p><b>Note:</b> Your credentials for Azure and PRTG will be stored in an encrypted format in our database. We need them to quickly onboard your AutoMonX SAAS tenant and start auto-discovery and monitoring immediately. </p>
      </div>
      {submitted ? (
        <div style={styles.successBox}>
          <p style={styles.successText}>
            Your form was successfully submitted! The provisioning of your AutoMonX SAAS is in progress.<br/>
            Check your mailbox for a confirmation email. Please note that it may take up to 10 minutes to complete.
          </p>
        </div>
      ) : (
        <form id="contactForm" onSubmit={handleSubmit} style={styles.form}>
          <label htmlFor="name" style={styles.label}>Full name:</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your full name"
            required
            style={styles.input}
          />

          <label htmlFor="company" style={styles.label}>Company name:</label>
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Enter your company name"
            required
            style={styles.input}
          />

          <label htmlFor="email" style={styles.label}>Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            required
            style={styles.input}
          />

          <label htmlFor="tenant" style={styles.label}>Azure Tenant ID:</label>
          <input
            type="text"
            id="tenant"
            name="tenant"
            placeholder="Enter your azure tenant id"
            required
            style={styles.input}
          />

          <label htmlFor="app" style={styles.label}>Azure App ID:</label>
          <input
            type="text"
            id="app"
            name="app"
            placeholder="Enter your azure app id"
            required
            style={styles.input}
          />
          <label htmlFor="secret" style={styles.label}>
            Azure Secret Key:
          </label>
          <div style={styles.passwordContainer}>
            <input
              type={showPassword ? "text" : "password"} // Toggle between password and text
              id="secret"
              name="secret"
              placeholder="Enter your azure secret key"
              required
              style={styles.input}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={styles.eyeButton}
              aria-label="Toggle password visibility"
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          <label style={styles.label}>
            <input
              type="checkbox"
              checked={showPRTG}
              onChange={() => setShowPRTG(!showPRTG)}
              style={{ marginRight: "8px" }}
            />
            Add PRTG Connection
          </label>

          {showPRTG && (
            <>
              <label htmlFor="prtg" style={styles.label}>PRTG Core IP:</label>
              <input
                type="text"
                id="prtg"
                name="prtg"
                placeholder="PRTG public IP or Hostname"
                style={styles.input}
              />

              <label htmlFor="prtgport" style={styles.label}>PRTG Core Web interface Port:</label>
              <input
                type="text"
                id="prtgport"
                name="prtgport"
                placeholder="PRTG Core Web Port (i.e. 443)"
                style={styles.input}
              />

              <label htmlFor="user" style={styles.label}>PRTG Username:</label>
              <input
                type="text"
                id="user"
                name="user"
                placeholder="Enter the PRTG username"
                style={styles.input}
              />

              <label style={styles.label}>Authentication Type:</label>
              <div style={styles.radioContainer}>
                <label style={styles.radioLabel}>
                  <input
                    type="radio"
                    value="passhash"
                    checked={prtgAuthType === "passhash"}
                    onChange={(e) => setPrtgAuthType(e.target.value)}
                    style={{ marginRight: "8px" }}
                  />
                  Passhash
                </label>
                <label style={styles.radioLabel}>
                  <input
                    type="radio"
                    value="apikey"
                    checked={prtgAuthType === "apikey"}
                    onChange={(e) => setPrtgAuthType(e.target.value)}
                    style={{ marginRight: "8px" }}
                  />
                  API Key
                </label>
              </div>

              <label htmlFor="pass" style={styles.label}>
                PRTG {prtgAuthType === "passhash" ? "passhash" : "API Key"}:
              </label>
              <div style={styles.passwordContainer}>
                <input
                  type={showPassword2 ? "text" : "password"} // Toggle between password and text
                  id="pass"
                  name="pass"
                  placeholder={`PRTG ${prtgAuthType === "passhash" ? "passhash" : "API key"}`}
                  style={styles.input}
                />
                <button
                  type="button"
                  onClick={togglePassword2Visibility}
                  style={styles.eyeButton}
                  aria-label="Toggle password visibility"
                >
                  {showPassword2 ? "Hide" : "Show"}
                </button>
              </div>
              
              <label htmlFor="probe" style={styles.label}>PRTG Probe IP:
                <Tooltip
                  title={
                    <>
                      You must provide the public IP of the PRTG Probe you plan to use to communicate with our SAAS offering. 
                      The IP of the probe will be added to our security systems. 
                      It can be the PRTG Core IP as well if you use the PRTG Local probe for monitoring.
                    </>
                  }
                >
                  <span style={styles.tooltipIcon}>?</span>
                </Tooltip>
                
              </label>
              <input
                type="text"
                id="prtguuid"
                name="prtguuid"
                placeholder="Enter your prtg probe ip"
                style={styles.input}
              />

              <label htmlFor="probename" style={styles.label}>PRTG Probe Name:
                <Tooltip
                  title={
                    <>
                      Enter the name of the PRTG Probe as it appears in PRTG UI - make sure to copy it from the Probe settings i.e. Local Probe.
                    </>
                  }
                >
                  <span style={styles.tooltipIcon}>?</span>
                </Tooltip>
                
              </label>
              <input
                type="text"
                id="prtgprobename"
                name="prtgprobename"
                placeholder="Enter your prtg probe name"
                style={styles.input}
              />
            </>
          )}

          <button type="submit" style={styles.button}>Submit</button>
        </form>
      )}
      <footer style={styles.footer}>
        For any questions email us at&nbsp;
        <a href="mailto:support@automonx.com">support@automonx.com</a>
      </footer>
    </div>
  );
}

// Styling
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //justifyContent: "center",
    padding: "40px 20px",
    fontFamily: "Segoe UI, sans-serif",
    backgroundColor: "#f0f4f8",
    minHeight: "100vh",
  },
  header: {
    marginBottom: "20px",
    color: "#2d2d2d",
    textAlign: "center",
    fontSize: "26px",
  },
  textContainer: {
    maxWidth: "700px",
    textAlign: "left",
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "8px",
    marginBottom: "30px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
    lineHeight: "1.6",
    color: "#333",
  },
  form: {
    maxWidth: "500px",
    width: "100%",
    background: "#ffffff",
    padding: "25px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontWeight: 600,
    color: "#444",
    fontSize: "15px",
  },
  radioContainer: {
    display: "flex",
    gap: "20px",
    marginBottom: "18px",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    fontWeight: 400,
    fontSize: "14px",
  },
  passwordContainer: {
    position: "relative",
    width: "100%",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginBottom: "18px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  eyeButton: {
    position: "absolute",
    right: "10px",
    top: "20px", 
    background: "transparent",
    transform: "translateY(-50%)",
    border: "none",
    cursor: "pointer",
    fontSize: "0.9rem",
    lineHeight: "1",
    padding: 0,
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#0078d7",
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  tooltipIcon: {
    display: "inline-block",
    marginLeft: "6px",
    color: "#0078d7",
    backgroundColor: "#e8f0fe",
    borderRadius: "50%",
    width: "16px",
    height: "16px",
    lineHeight: "16px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "bold",
    cursor: "help",
  },
  successBox: {                   
    maxWidth: "500px",
    width: "100%",
    background: "#ffffff",
    padding: "40px 30px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  successText: {                 
    fontSize: "18px",
    lineHeight: "1.6",
    color: "#2d2d2d",
    margin: 0,
  },
  footer: {
    marginTop: "40px",
    fontSize: "14px",
    color: "#6b6b6b",
    textAlign: "center",
  },
  errorContainer: {
    backgroundColor: "#ffeaea",
    border: "1px solid #ff6b6b",
    borderRadius: "5px",
    padding: "12px",
    marginBottom: "18px",
  },
  errorText: {
    color: "#d63031",
    fontSize: "14px",
    margin: 0,
    lineHeight: "1.4",
  },
};

export default Form;